import { Injectable } from '@angular/core';
import { HttpMethodType } from '@app/app.constant';
import { HttpCallService } from '@app/core/services/http-call.service';
import { INotificationParameterTypeHttpResponse, NotificationParameterType } from '@app/models/notification-settings';
import { map, Observable } from 'rxjs';

const HttpServiceMethods = {
  NotificationParameterType: 'NotificationParameterType'
};
@Injectable({
  providedIn: 'root'
})
export class NotificationParameterTypesService {

  constructor(private httpService: HttpCallService) { }

  public list(): Observable<NotificationParameterType[]> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationParameterType)
      .pipe(
        map((res) => res.map((item: INotificationParameterTypeHttpResponse) => NotificationParameterType.adapt(item)))
      );
  }

  public get(id: number): Observable<NotificationParameterType> {
    return this.httpService
      .callService(HttpMethodType.GET, HttpServiceMethods.NotificationParameterType + `/${id}`)
      .pipe(map((item: INotificationParameterTypeHttpResponse) => NotificationParameterType.adapt(item)));
  }

  public add(parameterType: NotificationParameterType) {
    return this.httpService.callService(
      HttpMethodType.POST,
      HttpServiceMethods.NotificationParameterType,
      parameterType
    );
  }

  public update(parameterType: NotificationParameterType) {
    return this.httpService.callService(
      HttpMethodType.PUT,
      HttpServiceMethods.NotificationParameterType,
      parameterType
    );
  }

  public delete(id: number) {
    return this.httpService.callService(
      HttpMethodType.DELETE,
      HttpServiceMethods.NotificationParameterType + `/${id}`
    );
  }
}
